import { render, staticRenderFns } from "./UpdateKubernetesSupportedVersion.vue?vue&type=template&id=48042fd1&scoped=true&"
import script from "./UpdateKubernetesSupportedVersion.vue?vue&type=script&lang=js&"
export * from "./UpdateKubernetesSupportedVersion.vue?vue&type=script&lang=js&"
import style0 from "./UpdateKubernetesSupportedVersion.vue?vue&type=style&index=0&id=48042fd1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48042fd1",
  null
  
)

export default component.exports